export default function strip (html) {
    return typeof html === 'string'
        ? html
            .replace(/\<[^\>]*\>/g, ' ')
            .replace(/&nbsp;/g, ' ')

        : '';
}